import { z } from "zod";
import { Messages } from "@arcware-cloud/shared-pixelstreaming-websdk";

/** Arcware Settings. */
export const ArcwareSettingsSchema = z.object({
  /** Overwrites the Session-Tool and uses the provided session instead. */
  session: z.string().optional(),
  /** Can be used to be added to the request in order to verify access to private projects.
   * For internal use only. => Preview page.
   */
  token: z.string().optional(),
  /** @deprecated in there for legacy use. Can only be used when token is provided. */
  bypass: z.boolean().optional(),
  // /** Configure DirectFlow Token. */
  // directFlow: z.string().optional(),
  /** Handler for server side error messages. */
  errorHandler: z.function().args(Messages.ZErrorMessage).returns(z.void()).optional(),
  /** Handler for queue events. */
  queueHandler: z.function().args(Messages.ZQueue).returns(z.void()).optional(),
  /** Handler for sessionId message. */
  sessionIdHandler: z.function().args(z.string()).returns(z.void()).optional(),
  /** Handler for love letters.
   * "LoveLetters" are send from backend to the SDK to state what phase the connection currently is in. */
  loveLetterHandler: z.function().args(Messages.ZLoveLetter).returns(z.void()).optional(),
  /** Show or hide the fullscreen button. */
  fullscreenButton: z.boolean().optional(),
  /** Show or hide the settings button. */
  settingsButton: z.boolean().optional(),
  /** Show or hide the info button. */
  infoButton: z.boolean().optional(),
  /** Show or hide the audio button. */
  audioButton: z.boolean().optional(),
  /** Show or hide the microphone button. */
  micButton: z.boolean().optional(),
  /** Show or hide the microphone button. */
  stopButton: z.boolean().optional(),
  /** Show or hide the connectionStrengthIcon button. */
  connectionStrengthIcon: z.boolean().optional(),

  /** ShareId, used for sharing your project.
   * Using ArcwareInit will set this required property for you. */
  shareId: z.string().startsWith("share-").optional(),
  /** Id of your project, only required if your shareId refers to multiple projects.
   * Using ArcwareInit will set this required property for you. */
  projectId: z.string().optional(),

  /** Enable/Disable LoveLetter logging to the console. */
  loveLetterLogging: z.boolean().optional(),
  /** Enable/Disable Connection Identifier logging to the console. */
  connectionIdentifierLoggingDisabled: z.boolean().optional(),
});

export type Settings = z.infer<typeof ArcwareSettingsSchema>;
